export const experienceRender = (e) => {
    const exp = e.data.experience;

    if (exp === undefined || exp === null || exp === '' || exp == '11') {
        return 'TBD';
    }

    return exp;
};
